import { render, staticRenderFns } from "./healthcareForm.vue?vue&type=template&id=254015a1&scoped=true"
import script from "./healthcareForm.vue?vue&type=script&lang=js"
export * from "./healthcareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254015a1",
  null
  
)

export default component.exports